import updateCurrentProductAndVariantIdFromUrlProductAction from 'modules/product/redux/actions/update-current-product-and-variant-id-from-url'
import loadByIdDeepProductVariantAction from 'modules/product-variant/redux/actions/load-by-id-deep'

/**
 * @returns {function(*): Promise<{resData: *}>}
 */
export default function loadByIdDeepAndUpdateCurrentProductVariantAction (variantId) {
  return async (dispatch) => {
    const logPrefix = `variantId=${variantId}`
    logUtil('loadByIdDeepAndUpdateCurrentProductVariantAction').debug(`${logPrefix} [start]`)

    const resData = await dispatch(loadByIdDeepProductVariantAction(variantId))
    logUtil('loadByIdDeepAndUpdateCurrentProductVariantAction').debug(`${logPrefix} resData=`, resData)
    if (!resData) {
      logUtil('loadByIdDeepAndUpdateCurrentProductVariantAction').debug(`${logPrefix} [noop] no resData`)
      return
    }

    dispatch(updateCurrentProductAndVariantIdFromUrlProductAction())
    logUtil('loadByIdDeepAndUpdateCurrentProductVariantAction').debug(`${logPrefix} [done]`)
    return resData
  }
}
